/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React from "react"
import Helmet from "react-helmet"
import PropTypes from "prop-types"
import { StaticQuery, graphql } from "gatsby"

import Header from "./header"
import Footer from "./footer"
import "./layout.css"

const Layout = ({ children }) => (
  <StaticQuery
    query={graphql`
      query SiteTitleQuery {
        site {
          siteMetadata {
            title
          }
        }
      }
    `}
    render={data => (
      <>
        <Helmet>
          {/* Tailwind from CDN */}
          {/* <link
            rel="stylesheet"
            href="https://unpkg.com/tailwindcss@2.0.1/dist/tailwind.min.css"
          /> */}
        </Helmet>
        <div className="layout-wrapper">
          <Header siteTitle={data.site.siteMetadata.title} />
          <div className="layout-main">
            <main className="layout-main">
              <div className="container">{children}</div>
            </main>
          </div>
          <Footer></Footer>
        </div>
      </>
    )}
  />
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
